import {SET_ACTIVE_TAB} from '../actions/tabs';
import {RESET_STATE} from "../actions/root";

const INITIAL_STATE = {
    tab: -1
};

const tabs = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ACTIVE_TAB:
            return {
                ...state,
                tab: action.tab
            };
        case RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
export default tabs;
